/* table with points table data,
   table data contain team (logo+team),
   played, won, loss, tie, S.D, points */
import "./PointsTable.css";

export default function PointsTable({ points }) {
  return (
    <div className="points-table-wrapper">
      <table className="points-table">
        <thead>
          <tr>
            <th>#</th>
            <th className="pt-team-col">Team</th>
            <th>P</th>
            <th>W</th>
            <th>L</th>
            <th>T</th>
            <th>S.D.</th>
            <th>Pts</th>
          </tr>
        </thead>
        <tbody>
          {/* sort copy of points in-place so original prop isn't mutated */}
          {[...(points || [])]
            .sort((a, b) => b.points - a.points)
            .map(
              (
                { team, logo, played, won, loss, tie, sd, points: pointsValue, status },
                index,
              ) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td className="pt-team-cell">
                    {logo && (
                      <img src={logo} alt={team} className="pt-team-logo" />
                    )}
                    <span className="pt-team-name">
                      {team}
                      {status && <span className="pt-team-status">({status})</span>}
                    </span>
                  </td>
                  <td>{played}</td>
                  <td>{won}</td>
                  <td>{loss}</td>
                  <td>{tie}</td>
                  <td>{sd}</td>
                  <td className="pt-points">{pointsValue}</td>
                </tr>
              ),
            )}
        </tbody>
      </table>
    </div>
  );
}
